import { PLATFORM } from '@/common/constants/platform-constants';
import React from 'react';
import NavHelps from './nav-helps';

export const SiteNavHelps = {
  [PLATFORM.STANDALONE]: null,
  [PLATFORM.STANDALONE_WOA]: <NavHelps />,
};
